import Link from 'next/link';

interface SearchItemWrapperProps {
  children: React.ReactNode;
  href: string;
}

export const SearchItemWrapper = ({ children, href }: SearchItemWrapperProps) => {
  return (
    <Link
      className="flex flex-col gap-2 py-[10px] cursor-pointer hover:bg-blue-50 rounded-[6px] transition"
      href={href}
    >
      {children}
    </Link>
  );
};
